<template>
  <form @submit.prevent>
    <div class="row">
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Bonus Adı</label>
              <input
                @blur="$v.bonus.name.$touch()"
                v-model="$v.bonus.name.$model"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': $v.bonus.name.$error }"
                placeholder="Bonus adı giriniz"
              />
              <small
                v-if="!$v.bonus.name.required && $v.bonus.name.$error"
                class="form-text text-danger"
              >Bu alan zorunludur...</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Açıklama 1</label>
              <span
                class="bonus-popover"
                @click="popoverClick"
                data-toggle="popover"
                data-placement="right"
                data-content="Masa Üstü Bonus Açıklaması 1.satır"
              >
                <i class="fas fa-question-circle ml-1"></i>
              </span>
              <input
                v-model="$v.bonus.altname.$model"
                type="text"
                class="form-control"
                placeholder="Bonus açıklama 1 giriniz"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Açıklama 2</label>
              <span
                class="bonus-popover"
                @click="popoverClick"
                data-toggle="popover"
                data-placement="right"
               data-content="Masa Üstü Bonus Açıklaması 2.satır"
              >
                <i class="fas fa-question-circle ml-1"></i>
              </span>
              <input
                v-model="$v.bonus.desname.$model"
                type="text"
                class="form-control"
                placeholder="Bonus açıklama 2 giriniz"
              />
            </div>
          </div>
          <div class="form-group col-md-4" :class="bonus.deger < 7 ? 'col-md-4' : 'col-md-6'">
            <label>Buton Yazısı</label>
            <span
              class="bonus-popover"
              @click="popoverClick"
              data-toggle="popover"
              data-placement="right"
              data-content="Bonus Talep Et Buton Yazısı"
            >
              <i class="fas fa-question-circle ml-1"></i>
            </span>
            <input
              v-model="$v.bonus.nameBtn.$model"
              type="text"
              class="form-control"
              placeholder="Buton yazısı giriniz"
            />
            <small
              v-if="!$v.bonus.nameBtn.required && $v.bonus.nameBtn.$error"
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
          </div>
          <div class="form-group col-md-4" :class="bonus.deger < 7 ? 'col-md-4' : 'col-md-6'">
            <label>Bonus Tipi</label>
            <select
              class="form-control"
              @blur="$v.bonus.deger.$touch()"
              v-model="$v.bonus.deger.$model"
              :class="{ 'is-invalid': $v.bonus.deger.$error }"
            >
              <option :value="null" disabled selected>Lütfen Bonus Türü Seçiniz</option>
              <option v-for="tur in bonusTur" :key="tur.val" :value="tur.val">{{ tur.name }}</option>
            </select>
            <small
              v-if="!$v.bonus.deger.required && $v.bonus.deger.$error"
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
          </div>
          <div class="col-md-4" v-if="bonus.deger < 7">
            <div class="form-group">
              <label>Backoffice Adı</label>
              <span
                class="bonus-popover"
                @click="popoverClick"
                data-toggle="popover"
                data-placement="right"
                data-content="Backoffice Panelde ki Bonus İsmiyle Birebir Aynı Olmalıdır"
              >
                <i class="fas fa-question-circle ml-1"></i>
              </span>
              <input
                @blur="$v.bonus.dagurName.$touch()"
                v-model="$v.bonus.dagurName.$model"
                type="text"
                class="form-control"
                placeholder="Backoffice adını giriniz"
              />
              <small
                v-if="!$v.bonus.dagurName.required && $v.bonus.dagurName.$error"
                class="form-text text-danger"
              >Bu alan zorunludur...</small>
            </div>
          </div>
          <div class="form-group col-md-4">
            <label>Günlük Limit</label>
            <span
              class="bonus-popover"
              @click="popoverClick"
              data-toggle="popover"
              data-placement="right"
              data-content="Günlük Maximum Eklenilebilecek Bonus Limiti"
            >
              <i class="fas fa-question-circle ml-1"></i>
            </span>
            <input
              @blur="$v.bonus.gunlukLimit.$touch()"
              v-model="$v.bonus.gunlukLimit.$model"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': $v.bonus.gunlukLimit.$error }"
            />
            <small
              v-if="
                !$v.bonus.gunlukLimit.required && $v.bonus.gunlukLimit.$error
              "
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
            <small
              v-if="
                !$v.bonus.gunlukLimit.numeric && $v.bonus.gunlukLimit.$error
              "
              class="form-text text-danger"
            >Negatif değer olamaz...</small>
          </div>
          <div class="form-group col-md-4">
            <label>Alt Limit</label>
            <span
              class="bonus-popover"
              @click="popoverClick"
              data-toggle="popover"
              data-placement="right"
              data-content="Bonustan Faydanılabilmek İçin Minumum Yatırım Tutarı"
            >
              <i class="fas fa-question-circle ml-1"></i>
            </span>
            <input
              @blur="$v.bonus.altLimit.$touch()"
              v-model="$v.bonus.altLimit.$model"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': $v.bonus.altLimit.$error }"
            />
            <small
              v-if="!$v.bonus.altLimit.required && $v.bonus.altLimit.$error"
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
            <small
              v-if="!$v.bonus.altLimit.numeric && $v.bonus.altLimit.$error"
              class="form-text text-danger"
            >Negatif değer olamaz...</small>
          </div>
          <div class="form-group col-md-4">
            <label>Üst Limit</label>
            <span
              class="bonus-popover"
              @click="popoverClick"
              data-toggle="popover"
              data-placement="right"
              data-content="Bonustan Faydanılabilmek İçin Maximum Yatırım Tutarı"
            >
              <i class="fas fa-question-circle ml-1"></i>
            </span>
            <input
              @blur="$v.bonus.ustLimit.$touch()"
              v-model="$v.bonus.ustLimit.$model"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': $v.bonus.ustLimit.$error }"
            />
            <small
              v-if="!$v.bonus.ustLimit.required && $v.bonus.ustLimit.$error"
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
            <small
              v-if="!$v.bonus.ustLimit.numeric && $v.bonus.ustLimit.$error"
              class="form-text text-danger"
            >Negatif değer olamaz...</small>
          </div>
          <div class="form-group col-md-6">
            <label>Başlangıç Tarihi</label>
            <input
              @blur="$v.bonus.baslangicTarih.$touch()"
              v-model="$v.bonus.baslangicTarih.$model"
              type="datetime-local"
              class="form-control"
              :class="{ 'is-invalid': $v.bonus.baslangicTarih.$error }"
            />
            <small
              v-if="
                !$v.bonus.baslangicTarih.required &&
                $v.bonus.baslangicTarih.$error
              "
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
          </div>
          <div class="form-group col-md-6">
            <label>Bitiş Tarihi</label>
            <input
              @blur="$v.bonus.bitisTarih.$touch()"
              v-model="$v.bonus.bitisTarih.$model"
              type="datetime-local"
              :min="bonus.baslangicTarih"
              class="form-control"
              :class="{ 'is-invalid': $v.bonus.bitisTarih.$error }"
            />
            <small
              v-if="!$v.bonus.bitisTarih.required && $v.bonus.bitisTarih.$error"
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
          </div>
          <div class="form-group col-md-4" :class="!bonus.isBirKere ? 'col-md-4' : 'col-md-6'">
            <label>Bir kerelik mi?</label>
            <span
              class="bonus-popover"
              @click="popoverClick"
              data-toggle="popover"
              data-placement="right"
              data-content="Bonustan Sadece Birkere mi Faydalanabilir Yoksa Çoklu Faydalanabilir mi Olduğunu Belirler"
            >
              <i class="fas fa-question-circle ml-1"></i>
            </span>
            <select
              @blur="$v.bonus.isBirKere.$touch()"
              v-model="$v.bonus.isBirKere.$model"
              class="form-control"
              :class="{ 'is-invalid': $v.bonus.isBirKere.$error }"
            >
              <option :value="null" disabled>Lütfen Seçiniz</option>
              <option :value="true">Evet</option>
              <option :value="false">Hayır</option>
            </select>
            <small
              v-if="!$v.bonus.isBirKere.required && $v.bonus.isBirKere.$error"
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
          </div>
          <div class="col-md-4" v-if="!bonus.isBirKere">
            <div class="form-group">
              <label>Tekrar</label>
              <span
                class="bonus-popover"
                @click="popoverClick"
                data-toggle="popover"
                data-placement="right"
                data-content="Bonustan Faydanıldıktan Kaç Gün Sonra Tekrar bu Bonustan Kullanabilir"
              >
                <i class="fas fa-question-circle ml-1"></i>
              </span>
              <input
                @blur="$v.bonus.tekrar.$touch()"
                v-model="$v.bonus.tekrar.$model"
                type="number"
                class="form-control"
                :class="{ 'is-invalid': $v.bonus.tekrar.$error }"
              />
              <small
                v-if="!$v.bonus.tekrar.required && $v.bonus.tekrar.$error"
                class="form-text text-danger"
              >Bu alan zorunludur...</small>
              <small
                v-if="!$v.bonus.tekrar.numeric && $v.bonus.tekrar.$error"
                class="form-text text-danger"
              >Negatif değer olamaz...</small>
            </div>
          </div>
          <div class="form-group col-md-4" :class="!bonus.isBirKere ? 'col-md-4' : 'col-md-6'">
            <label>Ekstra Özellikler</label>
            <span
              class="bonus-popover"
              @click="popoverClick"
              data-toggle="popover"
              data-placement="right"
              data-content="Özel Bonus Özellikleri ve Ortak Casino Spor Kayıplarının Belirlendiği Alan"
            >
              <i class="fas fa-question-circle ml-1"></i>
            </span>
            <multiselect
              v-model="bonus.discount"
              placeholder="Özellik Seçiniz"
              label="name"
              track-by="val"
              :options="discountOptions"
              :multiple="true"
              :taggable="false"
            ></multiselect>
          </div>
          <div class="form-group col-md-4">
            <label>Zamanlı mı?</label>
            <span
              class="bonus-popover"
              @click="popoverClick"
              data-toggle="popover"
              data-placement="right"
              data-content="Belirlinen Saatler Arasında Bonusun Alınmasını Sağlar"
            >
              <i class="fas fa-question-circle ml-1"></i>
            </span>
            <select
              @blur="$v.bonus.isTime.$touch()"
              v-model="$v.bonus.isTime.$model"
              class="form-control"
              :class="{ 'is-invalid': $v.bonus.isTime.$error }"
            >
              <option :value="null" disabled>Lütfen Seçiniz</option>
              <option :value="true">Evet</option>
              <option :value="false">Hayır</option>
            </select>
            <small
              v-if="!$v.bonus.isTime.required && $v.bonus.isTime.$error"
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
          </div>
          <div class="form-group col-md-4">
            <div class="form-group" v-if="bonus.isTime">
              <label>Başlangıç Saati</label>

              <input
                @blur="$v.bonus.timeStart.$touch()"
                v-model="$v.bonus.timeStart.$model"
                type="time"
                class="form-control"
                :class="{ 'is-invalid': $v.bonus.timeStart.$error }"
              />
              <small
                v-if="!$v.bonus.timeStart.required && $v.bonus.timeStart.$error"
                class="form-text text-danger"
              >Bu alan zorunludur...</small>
            </div>
          </div>
          <div class="form-group col-md-4">
            <div class="form-group" v-if="bonus.isTime">
              <label>Bitiş Saati</label>

              <input
                @blur="$v.bonus.timeFinish.$touch()"
                v-model="$v.bonus.timeFinish.$model"
                type="time"
                class="form-control"
                :class="{ 'is-invalid': $v.bonus.timeFinish.$error }"
              />
              <small
                v-if="!$v.bonus.timeStart.required && $v.bonus.timeStart.$error"
                class="form-text text-danger"
              >Bu alan zorunludur...</small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-12 d-flex justify-content-center">
            <div class="text-center">
              <img
                v-if="$route.params.id == 0"
                class="img-thumbnail"
                style="width: 225px; height: 65px"
                :src="imagePreview"
              />
              <a
                v-if="$route.params.id != 0"
                :href="BASE_HREF + 'files/bonus/' + bonus.image"
                target="_blank"
              >
                <img
                  class="img-thumbnail"
                  style="width: 225px; height: 65px"
                  :src="BASE_HREF + 'files/bonus/' + bonus.image"
                />
              </a>
            </div>
          </div>

          <div class="form-group col-md-12">
            <label>Bonus Resmi</label>
            <div class="input-group">
              <input type="hidden" v-model="bonus.image" />
              <div class="custom-file">
                <input
                  type="file"
                  class="custom-file-input"
                  @change="getFile"
                  ref="fileInput"
                  id="bonusImage"
                />
                <label class="custom-file-label" for="bonusImage">Dosya Seç</label>
                <div class="input-group-append"></div>
              </div>
            </div>
            <small
              v-if="!$v.bonus.image.required && $v.bonus.image.$error"
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
          </div>
          <div class="form-group col-md-12">
            <label>Sitede Görünsün mü?</label>
            <span
              class="bonus-popover"
              @click="popoverClick"
              data-toggle="popover"
              data-placement="right"
              data-content="Müşteriler Bonusu Görsün mü Görmesin mi Onu Belirtir"
            >
              <i class="fas fa-question-circle ml-1"></i>
            </span>
            <select
              @blur="$v.bonus.isShow.$touch()"
              v-model="$v.bonus.isShow.$model"
              class="form-control"
              :class="{ 'is-invalid': $v.bonus.isShow.$error }"
            >
              <option :value="null" disabled>Lütfen Seçiniz</option>
              <option :value="false">Evet</option>
              <option :value="true">Hayır</option>
            </select>
            <small
              v-if="!$v.bonus.isShow.required && $v.bonus.isShow.$error"
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
          </div>
          <div class="form-group col-md-12">
            <span class>
              <strong>VIP mi?</strong>
              <small class="text-danger">* Evet seçilirse bonus listesinden müşteri eklenebilir</small>
            </span>
            <select
              @blur="$v.bonus.isVip.$touch()"
              v-model="$v.bonus.isVip.$model"
              class="form-control mt-2"
              :class="{ 'is-invalid': $v.bonus.isVip.$error }"
            >
              <option :value="null" disabled>Lütfen Seçiniz</option>
              <option :value="true">Evet</option>
              <option :value="false">Hayır</option>
            </select>
            <small
              v-if="!$v.bonus.isVip.required && $v.bonus.isVip.$error"
              class="form-text text-danger"
            >Bu alan zorunludur...</small>
          </div>
          <div class="form-group col-md-12">
            <div class="form-group">
              <label>Günler</label>
              <span
                class="bonus-popover"
                @click="popoverClick"
                data-toggle="popover"
                data-placement="right"
                data-content="Sadece Belirlenen Günlerde Bonusun Alınmasını Sağlar"
              >
                <i class="fas fa-question-circle ml-1"></i>
              </span>
              <multiselect
                v-model="bonus.days"
                placeholder="Gün Seçiniz"
                label="name"
                track-by="name"
                :options="dayOptions"
                :multiple="true"
                :taggable="false"
              ></multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mt-2 d-flex justify-content-center">
        <button
          v-if="!bonus.ID"
          class="btn form-control btn-primary"
          @click="save()"
          :disabled="$v.bonus.$invalid"
        >
          <i class="fas fa-save"></i> Bonusu Kaydet
        </button>
        <button
          v-if="bonus.ID"
          class="btn form-control btn-success"
          @click="save(true)"
          :disabled="$v.bonus.$invalid"
        >
          <i class="fas fa-save"></i> Bonusu Güncelle
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import {
  required,
  between,
  numeric,
  requiredIf,
} from "vuelidate/lib/validators";
export default {
  data() {
    return {
      message: 'Hello Vue.js!',
      BASE_HREF: process.env.VUE_APP_BASEHREF,
      bonusID: this.$route.params.id,
      dayOptions: [
        { name: "Monday" },
        { name: "TuesDay" },
        { name: "Wednesday" },
        { name: "Thursday" },
        { name: "Friday" },
        { name: "Saturday" },
        { name: "Sunday" },
      ],
      discountOptions: [
        { val: "1", name: "Ortak Spor Kayıp" },
        { val: "2", name: "Ortak Casino Kayıp" },
        { val: "6", name: "Combo İşlem 300" },
        { val: "7", name: "Combo İşlem 150" },
        { val: "8", name: "Aviator Kayıp" },
        { val: "12", name: "Son Yatırımı Oku" },
      ],
      bonus: {
        ID: 0,
        name: "",
        dagurName: "",
        baslangicTarih: "",
        bitisTarih: "",
        deger: null,
        sortNumber: 0,
        nameBtn: "",
        altname: "",
        desname: "",
        days: [],
        gunlukLimit: 0,
        ustLimit: 0,
        altLimit: 0,
        tekrar: 0,
        discount: [],
        isShow: null,
        isBirKere: null,
        isVip: null,
        isTime: null,
        isDay: null,
        image: "",
        tekrar: 0,
        timeStart: "",
        timeFinish: "",
      },
      imagePreview: "src/assets/no-image.jpg",
      bonusTur: [
        // { val: 1, name: "Çevrimli Yatırım Bazlı" },
        { val: 2, name: "Çevrimli Aralık Bazlı" },
        // { val: 3, name: "Çevrimsiz Yatırım Bazlı" },
        { val: 4, name: "Çevrimsiz Aralık Bazlı" },
        // { val: 5, name: "Casino Yatırım bazlı " },
        { val: 6, name: "Casino Aralık bazlı " },
        { val: 7, name: "Freebet" },
        { val: 8, name: "Spor ve Casino Kayıp" },
        { val: 9, name: "Casino Özel Kayıp" },
        // { val: 10, name: "Rakeback" },
        { val: 11, name: "Aylık Kayıp" },
      ],
    };
  },
  validations: {
    bonus: {
      name: {
        required,
      },
      altname: { required },
      desname: {},
      nameBtn: { required },
      timeStart: {
        required: requiredIf(function (bonusModel) {
          return bonusModel.isTime;
        }),
      },
      timeFinish: {
        required: requiredIf(function (bonusModel) {
          return bonusModel.isTime;
        }),
      },
      dagurName: {
        required: requiredIf(function (bonusModel) {
          if (bonusModel.deger < 7) return true;
          else return false;
        }),
      },
      baslangicTarih: {
        required,
      },
      bitisTarih: {
        required,
      },
      deger: {
        required,
      },
      image: {
        required,
      },
      gunlukLimit: {
        required,
        numeric,
      },
      ustLimit: {
        required,
        numeric,
      },
      altLimit: {
        required,
        numeric,
      },

      tekrar: {
        required: requiredIf(function (bonusModel) {
          return !bonusModel.isBirkere;
        }),
        numeric,
      },
      isShow: {
        required,
      },
      isBirKere: {
        required,
      },
      isTime: {
        required,
      },
      // days: {
      //     required: requiredIf(function (bonusModel) {
      //         return bonusModel.isDay
      //     })
      // },
      isVip: {
        required,
      },
    },
  },
  computed: {},
  methods: {
    popoverClick() {
      $('[data-toggle="popover"]').popover()
    },
    getFile() {
      var fileToUpload = this.$refs.fileInput.files[0];
      var formData = new FormData();
      formData.append("image", fileToUpload);
      this.$http.post("Bonus/FileUpload", formData).then(
        (response) => {
          toastr.success("İşlem başarılı.");
          this.bonus.image = response.data;
          this.imagePreview = this.BASE_HREF + "/files/bonus/" + response.data;
        },
        (err) => {
          toastr.error(err.data.Message);
        }
      );
    },
    getBonus() {
      //**bonus id ye göre gelen verileri obj ile eşleyelim */
      this.$http.get("Bonus/GetBonus/" + this.bonusID).then(
        (response) => {
          this.bonus.days = [];
          const obj = response.data;
          this.$emit("bonus-name", obj.name);
          this.$emit("bonus-vip", obj.isVip);
          (this.bonus.ID = obj.ID),
            (this.bonus.name = obj.name),
            (this.bonus.dagurName = obj.dagurName),
            (this.bonus.baslangicTarih = obj.baslangicTarih),
            (this.bonus.bitisTarih = obj.bitisTarih),
            (this.bonus.deger = obj.gelenKampanyaTur),
            (this.bonus.sortNumber = obj.sortNumber),
            (this.bonus.nameBtn = obj.nameBtn),
            (this.bonus.altname = obj.altname),
            (this.bonus.desname = obj.desname),
            (this.bonus.gunlukLimit = obj.gunlukLimit),
            (this.bonus.ustLimit = obj.ustLimit),
            (this.bonus.altLimit = obj.altLimit),
            (this.bonus.tekrar = obj.tekrar),
            (this.bonus.isShow = obj.isShow),
            (this.bonus.isBirKere = obj.isBirKere),
            (this.bonus.isVip = obj.isVip),
            (this.bonus.isTime = obj.isTime),
            (this.bonus.isDay = obj.isDay),
            (this.bonus.image = obj.image),
            (this.bonus.tekrar = obj.tekrar),
            (this.bonus.timeStart = obj.timeStart),
            (this.bonus.timeFinish = obj.timeFinish);

          if (obj.days) {
            var arr = obj.days.split(",");
            arr.forEach((val) => {
              if (val) {
                this.bonus.days.push({ name: val });
              }
            });
          }
          if (obj.discount) {
            this.bonus.discount = [];
            var arr = obj.discount.split(",");
            arr.forEach((value) => {
              if (value) {
                this.discountOptions.forEach((item) => {
                  if (value == item.val) this.bonus.discount.push(item);
                });
              }
            });
          }
        },
        (err) => {
          toastr.error(err.data.Message);
        }
      );
    },
    save(type = false) {
      //**type true ise update false ise add işlemi */
      let endPoint = "";
      var formData = new FormData();
      if (!type) {
        //**eğer type false ise yani ekleme işlemi ise objmizden id keyini silelim */
        delete this.bonus["ID"];
        endPoint = "Bonus/AddBonus";
      } else {
        endPoint = "Bonus/EditBonus";
        formData.append("ID", this.bonus.ID);
      }
      //**birkerelik alanı evet seçilirse tekrarı 0 yapalım */
      if (this.bonus.isBirkere) this.bonus.tekrar = 0;
      //**zamanlı mı alanı hayır seçilirse başlangıç ve bitiş saati girilmesine gerek yok */
      if (!this.bonus.isTime) {
        this.bonus.timeStart = "";
        this.bonus.timeFinish = "";
      }
      if (this.bonus.deger > 6) this.dagurName = "";

      this.$http.post(endPoint, this.bonus).then(
        (response) => {
          toastr.success("İşlem başarılı.");
          if (type) this.getBonus();
          else this.$router.push(`/bonus-list/settings/info/${response.data}`);
        },
        (err) => {
          toastr.error(err.data.Message);
        }
      );
    },
    DateFormat(value) {
      if (!value) return "İşlem Sırasında";

      let date = value.split("T")[0].split("-");
      return date[0] + "-" + date[1] + "-" + date[2];
    },
  },

  created() {
    // if (this.bonusID != 0) {
    //     this.getBonusById();
    // }

  },
  beforeDestroy(){
    $('.popover').hide();
  },
  watch: {
    //**urlden değişiklikleri yakalamak için ilerde kullanılabilir */
    "$route.params.id": {
      handler: function (id) {
        if (id != 0) {
          this.bonusID = id;
          this.getBonus();

        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.bonus-popover {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/BonusList/BonusTabs/BonusInfo.vue